module.exports = __webpack_public_path__ + "img/shiyou-logo.09d6f5f8.png";